import { Pipe, PipeTransform } from '@angular/core';
import { coverageTypeDropdown } from '../consts/coverage-type-dropdown';

@Pipe({
  name: 'coverageTypeDescription',
  standalone: true,
})
export class CoverageTypeDescriptionPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (value == null || value === '') {
      return '--';
    }

    const ref = coverageTypeDropdown().find((item) => item.value === value);
    return ref ? ref.description : value;
  }
}
